import type { ConnectionEndpointSurface } from "./ConnectionEndpointProvider";

export type ConnectionRouteKind = "consumer-button" | "consumer-actor" | "consumer-scene" | "button-scene" | "terminal-via" | "other";
export type ConnectionRouteRule = Readonly<{
  id: string;
  kind: ConnectionRouteKind | "any";
  /** The plan device is first (consumer, or button for scenes/multiplexers), regardless of stored direction. */
  first: ConnectionEndpointSurface;
  second: ConnectionEndpointSurface;
  secondObjectClass?: string;
}>;

/** First matching rule wins. Exclusions (self-connections and equal roles) cannot be overridden here. */
export const DEFAULT_CONNECTION_ROUTE_RULES: readonly ConnectionRouteRule[] = Object.freeze([
  { id: "connection-dashboard", kind: "any", first: "connection-dashboard", second: "connection-dashboard" },
  { id: "connection-dashboard-button-editor", kind: "consumer-button", first: "connection-dashboard", second: "button-editor" },
  { id: "consumer-button-editor", kind: "consumer-button", first: "drawing", second: "button-editor" },
  {
    id: "consumer-button-drawing",
    kind: "consumer-button",
    first: "drawing",
    second: "drawing",
    secondObjectClass: "Button",
  },
  { id: "terminal-via-drawing", kind: "terminal-via", first: "drawing", second: "drawing" },
  { id: "consumer-actor-navigator", kind: "consumer-actor", first: "drawing", second: "navigator" },
  { id: "consumer-scene-navigator", kind: "consumer-scene", first: "drawing", second: "navigator" },
  { id: "button-scene-editor", kind: "button-scene", first: "button-editor", second: "navigator" },
  { id: "button-scene-navigator", kind: "button-scene", first: "drawing", second: "navigator" },
  { id: "consumer-navigator-button-editor", kind: "consumer-button", first: "navigator", second: "button-editor" },
  // A placed button remains the visible anchor even when its consumer is only in the navigator.
  {
    id: "consumer-navigator-button-drawing",
    kind: "consumer-button",
    first: "navigator",
    second: "drawing",
    secondObjectClass: "Button",
  },
  { id: "navigator-fallback", kind: "any", first: "navigator", second: "navigator" },
  // Room-list controls are only used when neither plan nor navigator supplies a route.
  { id: "room-consumers-button-editor", kind: "consumer-button", first: "room-consumers", second: "button-editor" },
  { id: "room-consumers-drawing", kind: "any", first: "room-consumers", second: "drawing" },
  { id: "room-consumers-navigator", kind: "any", first: "room-consumers", second: "navigator" },
] satisfies ConnectionRouteRule[]);
